import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import sectionStore from '../../store/sectionStore';

import PropTypes from 'prop-types';
import { showNotification } from '../notification/Notification';

const propTypes = {
  children: PropTypes.element,
};

const ConnectionChecker = observer(({ children }) => {
  const checkInterval = 5000; // Interval for checking internet connection (in milliseconds)

  const checkConnection = () => {
    const img = new Image();
    const timestamp = new Date().getTime();
    img.src = `https://www.gstatic.com/images/icons/material/system/2x/check_circle_black_24dp.png?${timestamp}`; // Cache-busting with timestamp

    img.onload = () => {
      sectionStore.setConnection(true);
    };

    img.onerror = () => {
      if (sectionStore.checkConnection === true) {
        showNotification(
          'You are offline. Please check your internet connection. Please save your work when you are online.'
        );
      }
      sectionStore.setConnection(false);
    };
  };

  useEffect(() => {
    checkConnection();
    const intervalId = setInterval(checkConnection, checkInterval);

    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line
  }, []);

  if (sectionStore.checkConnection) {
    return <>{children}</>;
  } else {
    return <>{children}</>; // Modify this part to show a custom component when offline
  }
});

ConnectionChecker.propTypes = propTypes;
export default ConnectionChecker;
